import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthResponse } from "reduxStore/dataTypes";

interface AdminAuthState {
  user: AuthResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminAuthState = {
  user: null,
  loading: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    authAdminRequest(state) {
      state.loading = true;
      state.error = null;
    },
    authAdminSuccess(state, action: PayloadAction<AuthResponse>) {
      state.loading = false;
      state.user = action.payload;
    },
    authAdminFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { authAdminRequest, authAdminSuccess, authAdminFailure } =
  adminAuthSlice.actions;
export default adminAuthSlice.reducer;
